import { Box, CircularProgress, TableCell, TableRow, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * Række der viser, at tabellen henter data eller er tom - i stedet for tom plads, som før
 * gjorde det svært at se, om siden hentede noget eller bare ikke havde noget at vise.
 */
const TableState = ({ colSpan, loading, text }: { colSpan: number; loading?: boolean; text?: string }) => {
  const [t] = useTranslation("global");
  return (
    <TableRow>
      <TableCell colSpan={colSpan} sx={{ py: 6, textAlign: "center", color: "text.secondary", borderBottom: 0 }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1.5 }}>
            <CircularProgress size={20} />
            <Typography variant="body2" color="text.secondary">
              {t("common.loading")}
            </Typography>
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">
            {text || t("common.noRows")}
          </Typography>
        )}
      </TableCell>
    </TableRow>
  );
};

export default TableState;
